import React, { useState, useEffect } from "react";
import PostShare from "./PostShare";
import PostDelete from "./PostDelete";
import PostTicket from "./PostTicket";
import { useUserContext } from "store/contexts/userContext";
import { useSelector } from "react-redux";

export default ({ post }) => {
  const { user } = useUserContext();
  const { teams } = useSelector((state) => state.teamsReducer);
  const [canDelete, setcanDelete] = useState(null);
  const [canShare, setcanShare] = useState(null);
  const [canCreateTicket, setcanCreateTicket] = useState(null);

  useEffect(() => {
    if (!teams) {
      return;
    }

    var result = teams?.some((team) => {
      if (post?.team_id !== team?.id) {
        return false;
      }

      if (![3, 2].includes(team?.role_id) && user?.id !== post?.user.id) {
        return false;
      }

      if ([1, 6, 8, 9, 10, 11].includes(post?.type_id)) {
        return true;
      }

      return false;
    });
    setcanDelete(result);

    //eslint-disable-next-line
  }, [teams, user]);

  useEffect(() => {
    if (!teams) {
      return;
    }

    var result = teams?.some((team) => {
      if (post?.team_id !== team?.id) {
        return false;
      }

      if ([6, 11].includes(post?.type_id) && !post?.data?.published) {
        return false;
      }

      if (post?.is_forwarded) {
        return false;
      }

      if ([3, 2].includes(team?.role_id)) {
        return true;
      }

      return false;
    });
    setcanShare(result);

    // Ticket visibility - only if user is admin/manager (role_id 2 or 3)
    var ticketResult = teams?.some((team) => {
      if (post?.team_id !== team?.id) {
        return false;
      }

      if ([3, 2].includes(team?.role_id)) {
        return true;
      }

      return false;
    });
    setcanCreateTicket(ticketResult);

    //eslint-disable-next-line
  }, [teams, user]);

  return (
    <div className="right-actions">
      {canShare && <PostShare myteam_id={post.team_id} post={post} />}
      {canCreateTicket && <PostTicket post={post} />}
      {canDelete && <PostDelete myteam_id={post.team_id} post={post} />}
    </div>
  );
};
